import React, { Fragment, useEffect } from "react";
import { useForm } from "react-hook-form";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import ToastDefault from "../FieldComponets/Toast";
import LogoImg from "../../assets/images/hroselylogo.jpg";
import { ErrorMessage } from "@hookform/error-message";
import { useDispatch, useSelector } from "react-redux";
import LogoBlack from "../../assets/images/main-logo-black.svg";
// import LogoImg from '../../assets/images/hroselylogo.jpg';
import { ForgotPasswordAction } from "../../Redux/Action/AuthAction";
import { APP_DEVELOPED_BY, APP_NAME, url } from "../../Config/Config";
import { StorageConstant } from "../../Constants/Constants";
import { getItemFromStorage } from "../../utils/Helper";
// const LogoImgs = require('../../assets/images/logo.png')
// const LogoImg = require('../../assets/images/hroselylogo.jpg');
// const LogoBlack = require('../../assets/images/main-logo-black.svg');
const LogoImgs = require("../../assets/images/loginLogo.jpg");
const Logo = require("../../assets/images/newLogo.png");

interface FormInputs {
  email: string;
}

function ForgotPassword() {
  const dispatch = useDispatch<any>();
  let navigate = useNavigate();
  const {
    register,
    formState: { errors },
    setValue,
    handleSubmit,
    getValues,
  } = useForm<FormInputs>();
  const ForgotPassword = useSelector((state: any) => state.ForgotPasswordState);

  const onSubmit = (data: FormInputs) => {
    dispatch(ForgotPasswordAction(data));
  };

  useEffect(() => {
    if (ForgotPassword?.status === true) {
      navigate(url + "/reset-password", { state: getValues("email") });
    }
    if (getItemFromStorage(StorageConstant?.is_admin_login_token) !== null) {
      setTimeout(function () {
        navigate(url + "/dashboard");
      }, 900);
    }
  }, [ForgotPassword?.status, ForgotPassword?.loading]);

  useEffect(() => {
    return () => {
      dispatch({ type: "FORGOT_PASSWORD_RESET" });
    };
  }, []);

  return (
    <Fragment>
      {ForgotPassword?.loading ? <Spinner /> : ""}
      <div className="auth-body-bg">
        <div className=" container-fluid p-0">
          <div className="row g-0">
            <div className="col-xl-3">
              <div className="auth-full-page-content p-md-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-4 mb-md-5">
                      <Link
                        to="/"
                        style={{ width: "170px" }}
                        className="mx-auto d-flex justify-content-center auth-logo"
                      >
                        <img className="w-100" src={Logo} alt="image" />
                      </Link>
                    </div>
                    <div className="my-auto">
                      <div>
                        <h5 className="theme-color"> Forgot Password?</h5>
                        {/* <p className="text-muted">Forgot Password with Horsely.</p> */}
                      </div>

                      <div className="mt-4">
                        <div
                          className="alert alert-success text-center mb-4"
                          role="alert"
                        >
                          Enter your Email and OTP will be sent to you!
                        </div>
                        <form
                          className="form-horizontal"
                          onSubmit={handleSubmit(onSubmit)}
                        >
                          <div className="mb-3">
                            <label htmlFor="username" className="form-label">
                              Email
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="username"
                              placeholder="Enter Email"
                              {...register("email", {
                                required: "Please enter valid email.",
                                pattern: {
                                  value: /^\S+@\S+\.\S+$/i,
                                  message: "Please enter valid Email.",
                                },
                              })}
                            />
                          </div>
                          <ErrorMessage
                            errors={errors}
                            name="email"
                            render={({ message }) => (
                              <p style={{ color: "red" }}>{message}</p>
                            )}
                          />
                          <div className="text-end">
                            <button
                              className="btn theme-bg text-white w-md waves-effect waves-light"
                              type="submit"
                            >
                              Reset
                            </button>
                          </div>
                        </form>
                        <div className="mt-5 text-center">
                          <p>
                            Remember It?{" "}
                            <Link
                              to={url + "/"}
                              className="fw-medium theme-color"
                            >
                              {" "}
                              Sign In here.
                            </Link>{" "}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="mt-4 mt-md-4 text-center">
                      <p>
                        ©{" "}
                        <script>
                          document.write(new Date().getFullYear())
                        </script>{" "}
                        {APP_NAME}. Crafted by {APP_DEVELOPED_BY}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-9 horselylogo">
              <img src={LogoImgs} alt="image" />
            </div>
          </div>
        </div>
      </div>
      <ToastDefault />
    </Fragment>
  );
}

export default ForgotPassword;
